const SensorKPI = function (options) {

}

SensorKPI.prototype = {
  importance: { DHTt: 0.15, DHTh: 0.1, ALS: 0.05, PM25: 0.25, CH2O: 0.25, CO2: 0.2 },
  greatValue: {
    DHTt: { a: 5, b: 19, c: 24, d: 32 },
    DHTh: { a: 10, b: 30, c: 60, d: 100 },
    ALS: { a: 30, b: 70, c: 90, d: 100 },
    PM25: { b: 0, c: 50, d: 200 },
    CH2O: { b: 0, c: 80, d: 160 },
    CO2: { b: 0, c: 450, d: 2000 }
  },
  suggestValue: {
    DHTt: { a: 5, b: 19, d: 28 },
    DHTh: { a: 30, d: 85 },
    ALS: { a: 50, d: 100 },
    PM25: { a: 0, d: 75 },
    CH2O: { a: 0, d: 80 },
    CO2: { a: 0, d: 2000 }
  },
  suggestText: {
    DHTt: ['温度较低，请打开空调设备', '温度较高，请打开风扇或空调'],
    DHTh: ['环境较为干燥，建议打开加湿设备', ''],
    ALS: ['室内较为昏暗，建议开灯或提高灯具亮度', ''],
    PM25: ['室内PM2.5含量较高，建议开启新风'],
    CH2O: ['室内甲醛含量较高，建议开启新风'],
    CO2: ['室内二氧化碳含量较高，建议开启新风']
  },
  exceptionValue: {
    DHTt: [40, 10],
    PM25: [350],
    CH2O: [250],
    CO2: [4500]
  },
  lowScore: 0,
  getKPI: function (sensor) {
    if (this._valid(sensor)) {
      if (this._exception(sensor)) {
        return this.lowScore
      } else {
        return this._calcScore(sensor)
      }
    } else {
      throw new Error('sensor params missing')
    }
  },
  getSuggest: function (sensor) {
    // 根据值进行命中Suggest
    var suggest = []
    for (let key in sensor) {
      if (!this.importance[key] || (sensor[key] >= this.suggestValue[key]['a'] && sensor[key] <= this.suggestValue[key]['d'])) {
        continue
      } else {
        if (this.suggestValue[key].hasOwnProperty('a') && sensor[key] <= this.suggestValue[key]['a']) {
          suggest.push(this.suggestText[key][0])
        } else if (this.suggestValue[key].hasOwnProperty('d') && sensor[key] >= this.suggestValue[key]['d']) {
          suggest.push(this.suggestText[key][this.suggestText[key].length > 1 ? 1 : 0])
        } else {
          continue
        }
      }
    }
    if (!suggest.length) {
      suggest.push('室内环境舒适')
    }
    return suggest
  },
  _valid: function (sensor) {
    if (sensor.hasOwnProperty('DHTt') && sensor.hasOwnProperty('PM25') && sensor.hasOwnProperty('CH2O') && sensor.hasOwnProperty('CO2') && sensor.hasOwnProperty('DHTh') && sensor.hasOwnProperty('ALS')) {
      return true
    }
    return false
  },
  _exception: function (sensor) {
    // 温度 > 40
    // 湿度 < 10
    // 亮度 不参与
    // PM25 > 250
    // 甲醛 > 250
    // 二氧化碳 > 4500
    var result = false
    for (var key in this.exceptionValue) {
      if (sensor[key] > this.exceptionValue[key][0] || (this.exceptionValue[key].length > 1 && sensor[key] < this.exceptionValue[key][1])) {
        result = true
        break
      }
    }
    return result
  },
  _calcScore: function (sensor) {
    let score = JSON.parse(JSON.stringify(this.importance))
    for (let key in this.importance) { // 循环计算每项得分
      if (sensor[key] >= this.greatValue[key]['b'] && sensor[key] <= this.greatValue[key]['c']) {
        score[key] = this.importance[key]
      } else {
        // 根据值线性调节，如果超出阈值，直接不得分
        if (this.greatValue[key].hasOwnProperty('a') && sensor[key] <= this.greatValue[key]['a']) {
          score[key] = this.lowScore
        } else if (this.greatValue[key].hasOwnProperty('d') && sensor[key] >= this.greatValue[key]['d']) {
          score[key] = this.lowScore
        } else {
          // 进行基础的线性计算，如果所属a侧  score = score - (score / (b-a)) * (b-value)
          if (this.greatValue[key].hasOwnProperty('a') && sensor[key] < this.greatValue[key]['b']) {
            score[key] = score[key] - (score[key] / (this.greatValue[key]['b'] - this.greatValue[key]['a'])) * (this.greatValue[key]['b'] - sensor[key])
          } else { // 进行基础的线性计算，如果所属d侧  score = score - (score / (d-c)) * (abs(value-d))
            score[key] = score[key] - (score[key] / (this.greatValue[key]['d'] - this.greatValue[key]['c'])) * (sensor[key] - this.greatValue[key]['c'])
          }
        }
      }
    }
    let total = 0
    for (let key in score) {
      total += (score[key] * 100)
    }
    return total
  }
}
export default new SensorKPI()
